import clsx from 'clsx';
import { getFullPermutation } from '@tencent/ywwriter-common/lib/utils/array';
const toastClassNames = {
    toast: [
        '@text-b2',
        '@flex',
        '@items-center',
        '@px-4',
        '@py-2.5',
        '@rounded',
        '@border',
        '@border-grey-2_3',
        '@bg-grey-1',
        '@shadow-down6',
        '@mt-0',
        '@whitespace-nowrap',
        '@select-none',
        // Vue Sonner 无法设置 icon 的 class
        '[&>[data-icon][data-icon]]:@relative',
        '[&>[data-icon][data-icon]]:@mr-2',
        '[&>[data-icon][data-icon]]:@w-6',
        '[&>[data-icon][data-icon]]:@h-6',
        '[&>[data-icon][data-icon]]:@my-[-2px]',
        '[&>[data-icon]>svg]:@w-full',
        '[&>[data-icon]>svg]:@h-full',
        // 覆盖 Vue Sonner icon Loading 状态
        '[&[data-sonner-toast][data-promise="true"]>[data-icon][data-icon]>svg]:@transform-none'
    ],
    icon: [
        '@w-6',
        '@h-6',
        '[&>svg]:@w-full',
        '[&>svg]:@h-full',
        '[&>.sonner-loader]:@flex',
    ],
    title: [
        // Vue Sonner 无法将 title 设为 unstyled
        '[&[data-title][data-title]]:@text-b2',
        '[&[data-title][data-title]]:@font-regular',
        '[&[data-title][data-title]]:@text-grey-6',
    ],
    description: [],
    // Vue Sonner 无法将 action button 设为 unstyled
    actionButton: [
        '[&[data-button][data-button]]:@ml-2',
        '[&[data-button][data-button]]:@text-b2',
        '[&[data-button][data-button]]:@px-0',
        '[&[data-button][data-button]]:@h-5',
        '[&[data-button][data-button]]:@bg-[transparent]',
        '[&[data-button][data-button]]:@text-brand1-1',
        'hover:[&[data-button][data-button]]:@text-brand-1-9',
        'hover:[&[data-button][data-button]]:@underline',
    ],
    cancelButton: [
        '[&[data-button][data-button]]:@ml-2',
        '[&[data-button][data-button]]:@text-b2',
        '[&[data-button][data-button]]:@px-0',
        '[&[data-button][data-button]]:@h-5',
        '[&[data-button][data-button]]:@bg-[transparent]',
        '[&[data-button][data-button]]:@text-red1-1',
        'hover:[&[data-button][data-button]]:@text-red-1-9',
        'hover:[&[data-button][data-button]]:@underline',
    ],
    // Vue Sonner 无法将 close button 设为 unstyled
    closeButton: [
        '[&[data-close-button][data-close-button]]:@relative',
        '[&[data-close-button][data-close-button]]:@transform-none',
        '[&[data-close-button][data-close-button]]:@order-last',
        '[&[data-close-button][data-close-button]]:@bg-[transparent]',
        '[&[data-close-button][data-close-button]]:@text-grey-6',
        '[&[data-close-button][data-close-button]]:@w-5',
        '[&[data-close-button][data-close-button]]:@h-5',
        '[&[data-close-button][data-close-button]]:@ml-2',
        '[&[data-close-button][data-close-button]]:@border-none',
        '[&[data-close-button][data-close-button]>svg]:@w-full',
        '[&[data-close-button][data-close-button]>svg]:@h-full',
    ],
    info: ['[&>[data-icon]]:@text-brand1-1'],
    success: ['[&>[data-icon]]:@text-success1-1'],
    error: ['[&>[data-icon]]:@text-red1-1'],
    warning: ['[&>[data-icon]]:@text-warning1-1'],
    loading: ['[&>[data-icon]]:@text-brand1-1'],
};
export const toastClassNamesMap = Object.fromEntries(Object.entries(toastClassNames).map(([k, list]) => [k, list.join(' ')]));
export const toastOptions = {
    unstyled: true,
    duration: 4000,
    classNames: toastClassNamesMap,
    classes: toastClassNamesMap,
};
export const toastStyle = `
  /* 设计要求居中对齐 */
  @media (min-width: 601px) {
    [data-sonner-toast][data-x-position="center"] {
      left: 50%;
      transform: translateX(-50%) var(--y);
    }
  }
  @media (max-width: 600px) {
    [data-sonner-toaster] [data-sonner-toast] {
      right: initial;
      width: auto;
      left: 50%;
      transform: translate(-50%, calc(var(--lift)* var(--offset)));
    }     
  }
`;
export const loadingClassName = clsx(
// 强行覆盖 Vue Sonner 的 loading 样式
'!@animate-spin', '!@opacity-100', '@w-6', '@h-6');
export const toasterStyles = {
    '--width': '356px',
    '--toast-icon-margin-start': '0',
    '--toast-icon-margin-end': '8px',
    '--toast-svg-margin-start': '0',
    '--toast-svg-margin-end': '0',
    '--toast-button-margin-start': '8px',
    '--toast-button-margin-end': '0',
    '--toast-close-button-start': '0',
    '--toast-close-button-end': '0',
    '--toast-close-button-transform': 'none'
};
export const DEFAULT_TOASTER_OFFSET = 32;
/**
 * 根据如栈时间戳的方式堆叠，保证最新的 offset 在最上面
 */
export class ValueStack {
    constructor(defaultValue) {
        this.stackMap = {};
        this.push(defaultValue, 0);
    }
    push(value, originKey) {
        const key = originKey !== null && originKey !== void 0 ? originKey : Date.now();
        this.stackMap[key] = value;
        return key;
    }
    pop(key) {
        // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this.stackMap[key];
    }
    getTopValue() {
        return Object.values(this.stackMap).pop();
    }
}
// 属性可变选择
export const toastVariantsMap = {
    type: ['', 'info', 'success', 'error', 'warning', 'loading'],
    promise: [false, 'success', 'error'],
    duration: [3000, 9000],
    closeButton: [false, true],
    action: [false, true],
    cancel: [false, true],
};
export const toastVariantNameMap = {
    type: '类型',
    promise: '异步任务',
    duration: '持续时间',
    closeButton: '关闭按钮',
    action: '操作按钮',
    cancel: '取消按钮',
};
const toEntry = (key, list) => list.map(v => ({ [key]: v }));
const SLOW_RATE = 1;
export const allToastMonads = getFullPermutation(Object.entries(toastVariantsMap).map(([key, list]) => toEntry(key, list)))
    .map(variants => Object.assign({}, ...variants))
    .map(variants => {
    const func = (toastFunc) => {
        const { type, promise, duration, closeButton, action, cancel } = variants;
        let message;
        let options = {
            duration: duration * SLOW_RATE,
            closeButton,
        };
        let fn = type ? toastFunc[type] : toastFunc;
        if (promise) {
            fn = toastFunc.promise;
            message = new Promise((resolve, reject) => {
                setTimeout(() => {
                    if (promise === 'success') {
                        resolve('success');
                    }
                    else {
                        reject(new Error('error'));
                    }
                }, 3000);
            });
            options = Object.assign(Object.assign({}, options), { loading: '执行中……', success: '成功！', error: '失败！' });
        }
        else {
            message = `你选择了「${type || '默认'}」类型的 Toast`;
        }
        if (action) {
            options = Object.assign(Object.assign({}, options), { action: {
                    label: '确认',
                    onClick: () => {
                        toastFunc.success('点击了确认');
                    },
                } });
        }
        if (cancel) {
            options = Object.assign(Object.assign({}, options), { cancel: {
                    label: '取消',
                    onClick: () => {
                        toastFunc.error('点击了取消');
                    },
                } });
        }
        fn(message, options);
    };
    func.variants = variants;
    return func;
});
